// @flow

import hexToRgba from 'hex-to-rgba';
import type { cssThemeSYType } from '../../../styles/themeSkillYoga';
import makeImageUrl from '../../../modules/makeImageUrl';
import { CLOUDFRONT_STATIC } from '../../../config/constants';

/* eslint-disable max-len */
export default function componentStyles(theme: cssThemeSYType) {
  return Object.freeze({
    '@global': {
      h2: {
        fontSize: theme.fontSize(22),
      },
    },

    heroContainer: {
      position: 'relative',
      display: 'flex',
      minHeight: theme.constants.ABOVE_FOLD_MOBILE_HEIGHT,
      alignItems: 'center',
      overflow: 'hidden',
      background: `${theme.colors.BLACK_COLOR} url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/576-min.jpg` })}) no-repeat center center / cover`,
    },

    heroContainerTrainingHome: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      minHeight: theme.constants.ABOVE_FOLD_MOBILE_HEIGHT_TRAINING_HOME,
      overflow: 'hidden',
      background: `${theme.colors.BLACK_COLOR} url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/576-min.jpg` })}) no-repeat center center / cover`,
    },

    heroContentTrainingHome: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingBottom: theme.rem(30),
      alignSelf: 'stretch',
      width: '100%',
      flexDirection: 'column',
      zIndex: 5,
      overflow: 'hidden',

      '& button': {
        maxWidth: "100%",
      },
    },

    heroContent: {
      position: 'relative',
      display: 'flex',
      alignSelf: 'stretch',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column',
      zIndex: 5,
      overflow: 'hidden',

      '& button': {
        width: theme.rem(290),
      },
    },

    heroTitle: {
      maxWidth: theme.rem(290),
      marginBottom: theme.getGutterSpacing(0.5),
      fontFamily: theme.fonts.EXTRA_LIGHT,
      textAlign: 'center',

      '& strong': {
        fontFamily: theme.fonts.MEDIUM,
      },
    },

    heroTitleTrainingHome: {
      marginBottom: theme.getGutterSpacing(0.5),
      fontFamily: theme.fonts.EXTRA_LIGHT,
      textAlign: 'center',

      '& strong': {
        fontFamily: theme.fonts.MEDIUM,
      },
    },
    
    heroTitleNextWorkout: {
      marginBottom: theme.getGutterSpacing(0.5),
      fontFamily: theme.fonts.EXTRA_LIGHT,
      textAlign: 'center',

      '& strong': {
        fontFamily: theme.fonts.MEDIUM,
      },
    },

    heroSubtitle: {
      fontSize: theme.fontSize(20),
      lineHeight: 1.25,
      marginBottom: theme.getGutterSpacing(3),
      textAlign: 'center',
    },

    skillCoachCtaAndPricing: {
      '& button': {
        width: '100%',
      },
    },

    skillCoachPricing: {
      marginTop: theme.getGutterSpacing(0.5),
      color: theme.colors.PAPER_WHITE_COLOR,
      textAlign: 'center',

      '& strong': {
        fontWeight: 700,
      },
    },

    elementWithBackgroundColor: {
      backgroundColor: hexToRgba(theme.colors.DARK_GREY_COLOR, 0.4),
    },

    trainingAppSpacing: {
      paddingTop: theme.rem(55),
      paddingBottom: theme.rem(61),
    },

    personalizedTrainingPlanSpacing: {
      paddingTop: theme.rem(57),
      paddingBottom: theme.rem(94),
    },

    skillCoachSpacing: {
      paddingTop: theme.rem(93),
      paddingBottom: theme.rem(100),
    },

    instagramOverviewSpacing: {
      paddingTop: theme.rem(93),
      paddingBottom: theme.rem(95),
    },

    blogArticlesSpacing: {
      paddingTop: theme.rem(96),
      paddingBottom: theme.rem(63),
    },

    bABetterAthleteSpacing: {
      paddingTop: theme.rem(90),
      paddingBottom: theme.rem(55),
    },

    endOfPageDivider: {
      display: 'none',
    },

    [theme.getBreakpoint('XS')]: {
      heroContainer: {
        backgroundImage: `url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/768-min.jpg` })})`,
      },

      heroTitle: {
        maxWidth: 'none',
      },
    },

    [theme.getBreakpoint('SM')]: {
      '@global': {
        h2: {
          fontSize: theme.fontSize(36),
        },
      },

      avatarName: {
        fontSize: theme.fontSize(30),
        lineHeight: 1.5,
      },

      heroContainer: {
        minHeight: theme.constants.ABOVE_FOLD_DESKTOP_HEIGHT,
        backgroundImage: `url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/922-min.jpg` })})`,
      },

      heroContainerTrainingHome: {
        minHeight: theme.constants.ABOVE_FOLD_MOBILE_HEIGHT_TRAINING_HOME,
        backgroundImage: `url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/922-min.jpg` })})`,
      },

      heroContent: {
        alignItems: 'flex-start',
        justifyContent: 'center',
      },

      heroContentTrainingHome: {
      },

      heroTitle: {
        textAlign: 'left',
      },

      heroTitleTrainingHome: {
        textAlign: 'center',
      },

      heroSubtitle: {
        fontSize: theme.fontSize(24),
        lineHeight: 1.5,
        marginBottom: theme.getGutterSpacing(3.5),
        textAlign: 'left',
      },

      trainingAppSpacing: {
        paddingTop: theme.rem(61),
        paddingBottom: theme.rem(52),
      },

      personalizedTrainingPlanSpacing: {
        paddingTop: theme.rem(61),
        paddingBottom: theme.rem(75),
      },

      skillCoachSpacing: {
        paddingTop: theme.rem(110),
        paddingBottom: theme.rem(43),
      },

      instagramOverviewSpacing: {
        paddingTop: theme.rem(142),
        paddingBottom: theme.rem(119),
      },

      blogArticlesSpacing: {
        paddingTop: theme.rem(138),
        paddingBottom: theme.rem(90),
      },

      bABetterAthleteSpacing: {
        paddingTop: theme.rem(110),
        paddingBottom: theme.rem(121),
      },

      endOfPageDivider: {
        display: 'block',
      },
    },

    [theme.getBreakpoint('MD')]: {
      heroContainer: {
        backgroundImage: `url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/1200-min.jpg` })})`,
      },
    },

    [theme.getBreakpoint('LG')]: {
      heroContainer: {
        backgroundImage: `url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/start/03-2021/1440-min.jpg` })})`,
      },
    },

    heroTitleLandingPage: {
      marginTop: theme.getGutterSpacing(1.2),
      marginBottom: theme.getGutterSpacing(0.5),
      fontFamily: theme.fonts.EXTRA_LIGHT,
      textAlign: 'left',
      fontSize: theme.fontSize(28),

      '& strong': {
        fontFamily: theme.fonts.MEDIUM,
      },
    },

    heroSubtitleLandingPage: {
      fontSize: theme.fontSize(15),
      lineHeight: 2.25,
      marginBottom: theme.getGutterSpacing(3),
      textAlign: 'left',
    },

    avatarName: {
      fontSize: theme.fontSize(20),
      lineHeight: 1.25,
      textAlign: 'left',
    },

    authorTitle: {
      fontSize: theme.fontSize(18),
      lineHeight: 0.75,
      textAlign: 'left',
    },

    avatarNamePaywall: {
      fontSize: theme.fontSize(13),
      fontWeight: "500",
      letterSpacing: "0.3px",
      lineHeight: "22px",
      textAlign: 'left',
    },
  });
}
/* eslint-enable max-len */
